import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import BrandLogo from "@/components/BrandLogo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Sıfırlama bağlantısı gönderildi");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-6">
      <div className="w-full max-w-[420px]" data-testid="forgot-page">
        <div className="mb-10">
          <BrandLogo size="lg" />
        </div>

        <h1 className="text-3xl tracking-tight font-bold text-slate-900 mb-2">Şifremi Unuttum</h1>
        <p className="text-sm text-slate-500 mb-8">
          Kayıtlı e-posta adresinizi girin. Sıfırlama bağlantısı e-postanıza gönderilecek.
        </p>

        {sent ? (
          <div className="rounded-lg border border-emerald-200 bg-emerald-50 text-emerald-800 px-4 py-4 text-sm" data-testid="forgot-success">
            E-posta adresi kayıtlıysa sıfırlama bağlantısı gönderildi. Lütfen gelen kutunuzu kontrol edin.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ornek@ajans.com"
              data-testid="forgot-email"
              className="w-full h-11 rounded-lg border border-slate-200 bg-white px-4 text-sm focus:outline-none focus:ring-1 focus:ring-slate-400 focus:border-slate-400 placeholder:text-slate-400"
            />
            {error && <div className="text-sm text-red-600">{error}</div>}
            <button
              type="submit"
              disabled={loading}
              data-testid="forgot-submit"
              className="w-full rounded-full bg-slate-900 text-white hover:bg-slate-800 h-11 font-medium transition-colors duration-150 disabled:opacity-50"
            >
              {loading ? "Gönderiliyor..." : "Sıfırlama Bağlantısı Gönder"}
            </button>
          </form>
        )}

        <div className="mt-6 text-sm">
          <Link to="/login" className="text-slate-500 hover:text-slate-900 transition-colors">← Girişe dön</Link>
        </div>
      </div>
    </div>
  );
}
